import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Images } from "../../theme";
import { AuthContext } from "../../context/AuthContext";
import { GlobalContext } from "../../context/GlobalContext";
import "./styles.css";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import { TranslatorDropdown } from "../";
import Swal from "sweetalert2";

export default ({ inPage, renderHit }) => {
  const userContextData = useContext(AuthContext);
  const globalContextData = useContext(GlobalContext);

  let { renderSearch, searchText } = globalContextData;
  let { user_data, loginData, user_logout, imageUrl, delete_account } =
    userContextData;
  let navigate = useNavigate();
  const { t } = useTranslation();

  // useEffect(() => {
  //   var addScript = document.createElement("script");
  //   addScript.setAttribute(
  //     "src",
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  //   );
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = googleTranslateElementInit;
  // }, []);

  // const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en",
  //       includedLanguages: "en,zh-CN",
  //       autoDisplay: false,
  //       layout: window.google.translate.TranslateElement.FloatPosition.TOP_LEFT,
  //     },
  //     "google_translate_element"
  //   );
  // };

  useEffect(() => {
    user_data();
  }, []);
  const checkValidation = () => {
    if (searchText) {
      if (inPage) renderHit(true);
      else navigate("/searchbycategory");
    }
  };

  function changeLanguage(e) {
    if (e.target.value == 2) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          delete_account();
        }
      });
    } else if (e.target.value == 3) user_logout();
  }

  return (
    <div class="bg-footer">
      <nav class="container navbar navbar-expand-lg navbar-light py-4">
        <div class="container-fluid">
          <a class="navbar-brand">
            <Link to="/">
              <img className="logo-icon" src={Images.logo_blue} alt="image" />
            </Link>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            href="#offcanvasExample"
            role="button"
            aria-controls="offcanvasExample"
          >
            <img src={Images.menu} />
          </button>
          <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul class="navbar-nav me-auto mb-lg-0">
              <li class="nav-item d-flex" style={{ marginLeft: 40 }}>
                <Link to="/Renting">
                  <a class="nav-link nav-text headerLanding">{t("Rent")}</a>
                </Link>
                <Link to="/Lending">
                  <a class="nav-link nav-text headerLanding">{t("Lend")}</a>
                </Link>
              </li>
            </ul>
            <div
              style={{ width: "37%" }}
              class="header-search input-slider input-group"
            >
              <input
                style={{ background: "#fff" }}
                type="text"
                class="form-control Montserrat MontserratSearch"
                placeholder={t("Search_Here")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={searchText}
                onChange={(e) => renderSearch(e.target.value)}
              />
              <Tooltip
                title={
                  searchText.length
                    ? `${t("Search")}`
                    : `${t("Please_Type_Some")}`
                }
              >
                <div class="input-group-append">
                  <button
                    class="bttn btn btn-outline-secondary"
                    type="button"
                    onClick={() => checkValidation()}
                  >
                    {t("Search")}
                  </button>
                </div>
              </Tooltip>
            </div>

            <form className="d-flex d-block-mobile">
              <button className="inbox poppins">
                <Link to="/Inbox">
                  <img src={Images.inbox} />
                  &nbsp;&nbsp;&nbsp;{t("Inbox")}
                </Link>
              </button>
              <div className="inbox poppins">
                <img
                  className="img22Ipad"
                  onClick={() => navigate("/Profile")}
                  src={
                    loginData.profileImagePath
                      ? `${imageUrl}${loginData.profileImagePath}`
                      : Images.user
                  }
                />
                <select
                  className="en Opensans"
                  style={{ color: "#005494" }}
                  onChange={changeLanguage}
                >
                  <option style={{ color: "black" }} value={1}>
                    {loginData?.firstname}
                  </option>
                  <option style={{ color: "black" }} value={2}>
                    Delete
                  </option>
                  <option style={{ color: "black" }} value={3}>
                    logout
                  </option>
                </select>
              </div>
              {/* <div className="en Opensans" id="google_translate_element" /> */}
              <TranslatorDropdown />
            </form>
          </div>
          <div
            class="offcanvas offcanvas-start"
            tabindex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div class="offcanvas-header">
              <a class="navbar-brand m-auto" href="#">
                <img className="logo-icon" src={Images.logo_blue} alt="image" />
              </a>
              <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav me-auto mb-lg-0">
                <li class="nav-item d-flex" style={{ marginLeft: 40 }}>
                  <Link to="/Renting">
                    <a class="nav-link nav-text headerLanding">{t("Rent")}</a>
                  </Link>
                  <Link to="/Lending">
                    <a class="nav-link nav-text headerLanding">{t("Lend")}</a>
                  </Link>
                </li>
              </ul>
              <div
                style={{ width: "37%" }}
                class="header-search input-slider input-group"
              >
                <input
                  style={{ background: "#fff" }}
                  type="text"
                  class="form-control Montserrat MontserratSearch"
                  placeholder={t("Search_Here")}
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  value={searchText}
                  onChange={(e) => renderSearch(e.target.value)}
                />
                <Tooltip
                  title={
                    searchText.length
                      ? `${t("Search")}`
                      : `${t("Please_Type_Some")}`
                  }
                >
                  <div class="input-group-append">
                    <button
                      class="bttn btn btn-outline-secondary"
                      type="button"
                    >
                      {t("Search")}
                    </button>
                  </div>
                </Tooltip>
              </div>
              <form className="d-flex d-block-mobile">
                <button className="mt-1 inbox poppins">
                  <Link to="/Inbox">
                    <img className="inbox-i" src={Images.inbox} />
                    {t("Inbox")}
                  </Link>
                </button>
                <TranslatorDropdown />
              </form>
              <Link to="/Profile">
                <button className="inbox inbox-bottom poppins">
                  <img
                    src={
                      loginData.profileImagePath
                        ? `${imageUrl}${loginData.profileImagePath}`
                        : Images.user
                    }
                  />
                  &nbsp;&nbsp;&nbsp;{loginData?.firstname} {loginData?.lastname}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
